import React, { FC }    from "react";
import { useDispatch }  from "react-redux";
import { Button, Icon } from "semantic-ui-react";
import RouterDispatcher from "../../../infrastructure/redux/router/RouterDispatcher";

const CustomerNewButton: FC = () => {
  const routerDispatcher: RouterDispatcher = new RouterDispatcher(useDispatch());
  return (
    <>
      <Button
        icon
        labelPosition="left"
        onClick={ () => routerDispatcher.customerRegister() }
      >
        <Icon name="plus"/>
        顧客を新しく追加する
      </Button>
    </>
  );
};

export default CustomerNewButton;
